import { config } from '../../../config';
import Benefit from '../entities/Benefit';
import { getRemoteData } from '../../../utils/firebase';

export default class BenefitsRepository {
  fetchAll(tenant = config.tenant): Promise<Benefit[]> {
    return getRemoteData(tenant)
      .then((remoteData) => {
        const parsedData = JSON.parse(remoteData);
        return parsedData?.benefits;
      })
      .catch(() => {
        throw new Error('Fetching benefits failed!');
      });
  }
}
